import * as React from 'react';

import {HelpModal} from 'shells/modal/help-modal';
import {SpacerGroup} from 'shells/spacer/spacer-group';
import {ModalBody} from 'shells/typography/modal-body';
import {ModalHeader} from 'shells/typography/modal-header';

import {UndeliverableModalGraphic} from './assets';

import styles from './tooltip-modal-styles.module.css';

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

export function MessageUndeliverableModal(props: Props) {
    return (
        <HelpModal
            isOpen={props.isOpen}
            onClose={props.onClose}
            artImage={<UndeliverableModalGraphic />}
            bodyComponent={
                <div className={styles.container}>
                    <ModalHeader>Undeliverable rate</ModalHeader>
                    <SpacerGroup mb={32}>
                        <ModalBody>
                            The undeliverable rate reflects the percentage of messages that were not
                            successfully delivered.
                        </ModalBody>
                    </SpacerGroup>
                    <SpacerGroup mb={32}>
                        <ModalBody>
                            This can occur for several reasons, such as an incorrect phone number,
                            poor network signal, or if the recipient has blocked your number.
                        </ModalBody>
                    </SpacerGroup>
                </div>
            }
        />
    );
}
